import {useRef} from "react";
import {objectIcons} from "./icons";
import styles from "./index.module.scss";

export default function ScriptNode({nodeObject, depth, onClickScriptItem}) {
  const {name, type, title, uuid, userData} = nodeObject;

  const node = useRef();
  const childrenGap = useRef();

  const titleWidth = 133 - 20 * depth;
  const childrenGapWidth = 208 - 20 * (depth + 1);

  return (
    <div className={styles.container} uuid={uuid}>
      <div className={`${styles.content}`} ref={node} location={"node"}>
        <div className={styles.icon_front}>
          <ObjectIcon type={type} name={name} userData={userData} />
        </div>
        <div className={styles.title} style={{width: titleWidth}}>
          {title}
        </div>
      </div>
      <>
        <div className={styles.gap}>
          <div
            className={styles.gap_indicator}
            style={{width: childrenGapWidth, marginLeft: 240 - childrenGapWidth, zIndex: depth}}
            ref={childrenGap}
            location={"childrenGap"}
          >
            <div className={styles.gap_area}></div>
          </div>
        </div>
        <div className={styles.children}>
          <ScriptGroup onClickScriptItem={onClickScriptItem} />
        </div>
      </>
    </div>
  );
}

function ObjectIcon() {
  return objectIcons["World"];
}

const ScriptGroup = ({onClickScriptItem}) => {
  return (
    <div className={styles.scripts_wrapper}>
      <ScriptItem onClickScriptItem={onClickScriptItem} />
    </div>
  );
};

const ScriptItem = ({onClickScriptItem}) => {
  return (
    <div className={styles.script_container} onClick={onClickScriptItem}>
      <div className={styles.script_content}>
        <div className={styles.script_title}>Default Script</div>
      </div>
    </div>
  );
};
